export const singleSearchPOICategories: string[] = [
  'CAT Scales',
  'Truck Services',
  'Manufacturing Plant',
  'Distribution Center',
  'Weigh Station',
  'Walmart Overnight Parking',
  'Intermodal Terminal',
  'LCV Lot',
];
